import React from 'react'
import { graphql } from 'gatsby'
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";

const ImageBanner = ({image}) => {
  return (
    <section className="image-banner">
      <div className="image-banner__inner">
        <div className='image-banner__wrapper'>
          {image && <Asset className="landing-banner__bg" asset={image}/>}
        </div>
      </div>
    </section>
  )
}

export default ImageBanner

export const query = graphql`
fragment ImageBannerProps on DatoCmsImageBanner {
  ... on DatoCmsImageBanner {
    id
    image {
      ...InternalAssetProps
    }
  }
}
`;